import React from 'react'
import { LogEntry } from '../types'
import { getUserLabel } from '../services/userLabel'
import useStyles from '../styles'

interface LogUserCellProps {
  entry: LogEntry
}

const LogUserCell: React.FC<LogUserCellProps> = ({ entry }) => {
  const classes = useStyles()
  const userLabel = getUserLabel(entry)

  return (
    <div
      className={classes.logUser}
      title={userLabel.label}
    >
      <span
        className={`${classes.userChip} ${
          userLabel.kind === 'system' ? classes.userChipSystem : ''
        }`}
      >
        {userLabel.label}
      </span>
    </div>
  )
}

export default LogUserCell
